module.exports = __webpack_public_path__ + "static/media/girl-up.9f1b7d1d.png";